import styled, { css } from "styled-components";

const ElipsisTd = styled.td`
  max-width: 0;
  min-width: 100px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

const BiggerElipsisTd = styled.td`
  max-width: 0;
  min-width: 180px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

const WaitingForResult = styled.td`
  text-align: center;
  color: #aaa;
`;

const CenterTd = styled.td`
  text-align: center;
`;
const Td = styled.td`
  ${props =>
    props.reviewed &&
    css`
      background-color: #ccffcc;
    `};
  ${props =>
    (props.failed &&
      css`
        background-color: #ffe3e3 !important;
      `) ||
    (props.warning &&
      css`
        background-color: #ffeecf !important;
      `)};
`;

const EmptyTd = styled.td`
  background-color: rgb(251, 251, 251);
  color: #ddd;
`;

const CaveatTd = styled.td`
  & input {
    padding: 0px;
    margin: 0px;
    vertical-align: middle;
  }
  & ul {
    padding-left: 0px;
    list-style-type: none;
  }
  & ul li {
    padding: 3px;
  }
  ul {
    margin: 0px;
  }
`;

const LimitSpan = styled.span`
  margin-right: 5px;
  ${props =>
    props.type == "pass_fail" &&
    css`
      color: red;
    `}
  ${props =>
    props.type == "warning" &&
    css`
      color: orange;
    `}
`;

export {
  ElipsisTd,
  BiggerElipsisTd,
  CenterTd,
  Td,
  CaveatTd,
  LimitSpan,
  EmptyTd,
  WaitingForResult
};
